<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                honeyTypeForm: () => import('../forms/HoneyTypeForm'),
                memberForm: () => import('../forms/MemberForm'),
                productForm: () => import('../forms/ProductForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'autocomplete', text: 'Product', value: 'productId', rules: [v => !!v || 'Product is required'], isRequired: true, form: () => import('./ProductForm'), apiMethod: 'Products', claim: 'Products' },
                    { type: 'autocomplete', text: 'Honey Type', value: 'honeyTypeId', rules: [v => !!v || 'Honey Type is required'], isRequired: true, form: () => import('./HoneyTypeForm'), apiMethod: 'HoneyTypes', claim: 'HoneyTypes' },
                    { type: 'text', text: 'Activity Grade', value: 'activityGrade', rules: [v => !(v && v.length > 100) || 'Activity Grade must be less than 100 characters'], maxLength: 100 },
                    { type: 'text', text: 'For Client', value: 'forClient', rules: [v => !(v && v.length > 100) || 'For Client must be less than 100 characters'], maxLength: 100 },
                    { type: 'checkbox', text: 'Is Blend', value: 'isBlend', rules: [v => (v !== null && v !== '') || 'Is Blend is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Passed Testing', value: 'hasPassedTesting', rules: [v => (v !== null && v !== '') || 'Has Passed Testing is required'], isRequired: true },
                ],
                apiMethod: 'Samplings',
                formTitle: 'Sampling',
            }
        },
    };
</script>
